import { z } from "zod";

export const temperatures = ['ambient', 'cold', 'low', 'high'] as const;
export const equipmentTypes = ['Pipe', 'Vessel', 'Equipment', 'Structure', 'Riser', 'Tank'];
export const pictureDescription = ['yes', 'no'] as const;
export const conditionCodes = ['A', 'B', 'C', 'D'] as const;

export const reviewSchema = z.object({
    onSiteEngineerName: z.object({
        label: z.string(),
        value: z.string(),
        __isNew__: z.boolean().optional(),
    }),
    reportReviewerName: z.object({
        label: z.string(),
        value: z.string(),
        __isNew__: z.boolean().optional(),
    }),
    mciLeaderName: z.object({
        label: z.string(),
        value: z.string(),
        __isNew__: z.boolean().optional(),
    }),
    onSiteReviewDate: z.date({ coerce: true }),
    reportReviewerRecommendation: z.string(),
    reportReviewDate: z.date({ coerce: true }),
    mciReviewDate: z.date({ coerce: true }),
});

export const informationSchema = z.object({
    tagNumber: z.string(),
    identificationInformation: z.string(),
    installation: z.string(),
    systemNumber: z.string(),
    functionalLocation: z.string(),
    pressure: z.number().positive(),
    temperature: z.enum(temperatures),
    process: z.string(),
    pidNumber: z.string(),
    module: z.object({
        label: z.string(),
        value: z.string(),
        __isN__: z.boolean().optional(),
    }),
    location: z.string(),
    pictureDescription: z.enum(pictureDescription),
    equipmentType: z.string(),
    conditionCode: z.enum(conditionCodes),
    category: z.string(),
    ramAssessment: z.string(),
    anomalyDescription: z.string(),
    remedialAction: z.string(),
    dateOfFinding: z.date({ coerce: true }),
});

export const cdrReportNumber = z.object({
    cdrReportNumber: z.string(),
});

export type CDRReportNumber = z.infer<typeof cdrReportNumber>;
export type CDRReviewInformation = z.infer<typeof reviewSchema>;
export type CDRInformationModel = z.infer<typeof informationSchema>;


